<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      v-if="!create"
      :schema="schema"
      name="code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.code"
        :form-state="formState"
        name="code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.code"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="job"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <job-search
        v-model="item.job"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        name="job"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job"
        @update-job="updateJob"
        :create="create"
        :address="item.site_address"
        :suburb="item.suburb"
        :job_number="item.job"
      >
      </job-search>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="builder"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        :value="item.job__customer__name"
        :items="optionCustomerItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionCustomerWorking"
        name="job__customer__name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job__customer__name"
        readonly
      >
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="invoice_reference"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.invoice_reference"
        :form-state="formState"
        name="invoice_reference"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.invoice_reference"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="credit_adj_ref_amount_inc_gst"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        prepend="$"
        v-model="item.credit_adj_ref_amount_inc_gst"
        :form-state="formState"
        name="credit_adj_ref_amount_inc_gst"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.credit_adj_ref_amount_inc_gst"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="credit_requested"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.credit_requested"
        :form-state="formState"
        name="credit_requested"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.credit_requested"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supervisor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.supervisor_name"
        :form-state="formState"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
      >
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="subcontractor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.subcontractor"
        :form-state="formState"
        name="subcontractor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.subcontractor"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="site_address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.site_address"
        :form-state="formState"
        name="site_address"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.site_address"
        readonly
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="suburb"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.suburb"
        :form-state="formState"
        name="suburb"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.suburb"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="category_of_works"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.category_of_works"
        :items="optionCodeCategoryOfWorkItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeCategoryOfWorkWorking"
        name="category_of_works"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.category_of_works"
        allow-add
        store-name="CodeCategoryOfWork"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-category-of-work-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-category-of-work-form>
        </template>
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="description"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.description"
        :form-state="formState"
        name="description"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.description"
      ></o-text-area>
    </o-widget-wrapper>

    <tax-inputs
      :item="item"
      inc-amount-field="amount"
      ex-amount-field="amount_ex_gst"
      :form-state="formState"
      :schema="schema"
      :v="$v"
      :server-errors="_se"
    ></tax-inputs>

    <o-widget-wrapper
      :schema="schema"
      name="authorised_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.authorised_by"
        :form-state="formState"
        name="authorised_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.authorised_by"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="authorised_by_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.authorised_by_date"
        name="authorised_by_date"
        v-bind="schema.fields.authorised_by_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="awaiting_authorisation"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.awaiting_authorisation"
        :form-state="formState"
        name="awaiting_authorisation"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.awaiting_authorisation"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="awaiting_authorisation_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.awaiting_authorisation_date"
        name="awaiting_authorisation_date"
        v-bind="schema.fields.awaiting_authorisation_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
        :readonly="!item.awaiting_authorisation"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="further_info_requested"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.further_info_requested"
        :form-state="formState"
        name="further_info_requested"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.further_info_requested"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="further_info_requested_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.further_info_requested_date"
        name="further_info_requested_date"
        v-bind="schema.fields.further_info_requested_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
        :readonly="!item.further_info_requested"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="repair_notes"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-notes-table
        :form-state="formState"
        :label="schema.fields.repair_notes.label"
        :level="level + 1"
        :server-errors="_se.repair_notes"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :validator="$v.item.repair_notes"
        model-name="Note"
        v-model="item.repair_notes"
        when-field="when"
        who-field="who"
      >
      </o-notes-table>
      <!-- UNCOMMENT TO USE Cards
<note-form-cards v-model="item.repair_notes"
    :validators="$v.item.repair_notes"
    :form-state="formState"
    :label="schema.fields.repair_notes.label"
    :level="level+1"
    :server-errors="_se.repair_notes">
</note-form-cards>
--> </o-widget-wrapper
    ><br />

    <o-widget-wrapper
      :schema="schema"
      name="billing_to"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <service-recharge-bill-to-form-table
        v-model="item.billing_to"
        :validators="$v.item.billing_to"
        :form-state="formState"
        :label="schema.fields.billing_to.label"
        :level="level + 1"
        :server-errors="_se.billing_to"
        @total_billed_change="totalBilledChange"
      >
      </service-recharge-bill-to-form-table>
      <!-- UNCOMMENT TO USE Cards
<service-recharge-bill-to-form-cards v-model="item.billing_to"
    :validators="$v.item.billing_to"
    :form-state="formState"
    :label="schema.fields.billing_to.label"
    :level="level+1"
    :server-errors="_se.billing_to">
</service-recharge-bill-to-form-cards>
--> </o-widget-wrapper
    ><br />

    <o-widget-wrapper
      :schema="schema"
      name="sales_order_created"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.sales_order_created"
        :form-state="formState"
        name="sales_order_created"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.sales_order_created"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="sales_order_created_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.sales_order_created_date"
        name="sales_order_created_date"
        v-bind="schema.fields.sales_order_created_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
        :readonly="!item.sales_order_created"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="variance && !create"
      :schema="schema"
      name="amount_variance"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        :prepend="moneySymbol"
        default-class="w-50"
        changeColor="border-red"
        col-size="6"
        v-model="item.amount_variance"
        :form-state="formState"
        name="amount_variance"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_variance"
        readonly
      ></o-money-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="repair_files"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <file-upload-form-table
        :form-state="formState"
        :label="schema.fields.repair_files.label"
        :level="level + 1"
        :server-errors="_se.repair_files"
        :validators="$v.item.repair_files"
        :parent-id="item.id || 0"
        parent-type="service_recharge"
        v-model="item.repair_files"
      >
      </file-upload-form-table>
      <!-- <o-files-table
        v-model="item.repair_files"
        model-name="FileUpload"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :file-types="optionCodeFileTypeItems"
        :file-types-working="optionCodeFileTypeWorking"
        who-field="who_uploaded"
        when-field="when_uploaded"
        :validators="$v.item.repair_files"
        :form-state="formState"
        :label="schema.fields.repair_files.label"
        :level="level + 1"
        :server-errors="_se.repair_files"
      >
      </o-files-table> -->
    </o-widget-wrapper>
    <br />
    <o-widget-wrapper
      :schema="schema"
      name="cancelled_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.cancelled_date"
        name="cancelled_date"
        v-bind="schema.fields.cancelled_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OMoneyField from "../../components/money_field/OMoneyField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";
import OFilesTable from "../../../vue-ocom/components/table/common/OFilesTable";

import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as JobForm } from "../../job/components/ItemForm";
// import { default as FileUploadFormTable } from '../../file_upload/components/ItemFormTable';
// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
import { default as FileUploadFormTable } from "../../../app/file_upload/components/ItemFormTable";
import { default as RepairMaterialsUsedFormTable } from "../../repair_materials_used/components/ItemFormTable";
// import { default as RepairMaterialsUsedFormCards } from '../../repair_materials_used/components/ItemFormCards';
// import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as ServiceRechargeBillToFormTable } from "../../service_recharge_bill_to/components/ItemFormTable";
// import { default as ServiceRechargeBillToFormCards } from '../../service_recharge_bill_to/components/ItemFormCards';
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as CodeCategoryOfWorkForm } from "../../code_category_of_work/components/ItemForm";
import TaxInputs from "@/app/components/TaxInputs.vue";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServiceRecharge"),
    CreateCodeTableFetchMixin([
      "Customer",
      "Supervisor",
      "Supplier",
      "User",
      "CodeFileType",
      "CodeCategoryOfWork",
    ]),
    CrewSupplierMixin(),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OMoneyField,
    OTextArea,

    CustomerForm,
    SupervisorForm,
    JobForm,
    FileUploadFormTable,
    //FileUploadFormCards,
    RepairMaterialsUsedFormTable,
    //RepairMaterialsUsedFormCards,
    //NoteFormTable,
    //NoteFormCards,
    ServiceRechargeBillToFormTable,
    //ServiceRechargeBillToFormCards,
    InvoiceFormTable,
    //InvoiceFormCards,
    ONotesTable,
    JobSearch,
    OFilesTable,
    CodeCategoryOfWorkForm,
    TaxInputs,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.ServiceRecharge, {}),
    moneySymbol: "$",
  }),
  methods: {
    updateJob(e) {
      this.item.job = e.id;
      this.item.site_address = e.site_address;
      this.item.suburb = e.suburb;

      // Set a 'subcontractor' name for display. NOT STORED
      if (e.crew_supplier)
        this.item.subcontractor = this.optionCrewItemsById[
          e.crew_supplier
        ].name;
      else this.item.subcontractor = "-";

      if (e.customer) {
        this.item.builder = e.customer;
        this.item.job__customer__name = e.customer__name;
      }

      this.item.old_job_no = e.original_job_number;
    },
    variance() {
      var result =
        parseFloat(this.item.total_billed || 0) -
        parseFloat(this.item.total_invoiced || 0);

      result = +(result || 0).toFixed(2);

      this.item.amount_variance = result.toFixed(2);

      return result;
    },
    totalBilledChange(new_total_billed) {
      this.item.total_billed = new_total_billed;
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
